module.exports = __webpack_public_path__ + "img/logo-transparent.31f188b8.png";